import { createUseStyles } from 'react-jss';

export default createUseStyles(
  {
    root: {
      position: 'sticky',
      top: '0',
      marginLeft: '20px',
      marginRight: '20px',
      marginTop: '14px',
      height: '110px',
    },
    header: {
      marginTop: '20px',
      marginBottom: '20px',
    },
    canaryManagement: {
      height: '100%',
    },
  },
  {
    name: 'CanaryUsers',
  },
);
